import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import * as nativeAppAction from 'yoda-site-components/lib/actions/NativeAppAction';
import Button from 'yoda-core-components/lib/components/Button';
import * as messageContentAction from 'yoda-checkout-components/lib/actions/MessageContentAction';
import get from 'lodash/get';
import {
    EMPTY_CART_START_SHPNG,
    EMPTY_CART_CART_IS_EMPTY,
    EMPTY_CART_CONTENT,
    EMPTY_CART_VIEW_COUPONS,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './EmptyCart.css';
import { CART_DETAILS_GET_REQUEST } from '../../actionTypes/CartActionTypes';

const cx = classNames.bind(styles);
/* istanbul ignore next */
const handleCouponBtn = () => {
    window.location.href = '/m/jcpenney-coupons';
};
/* istanbul ignore next */
const handleShoppingBtn = () => {
    window.location.href = '/';
};

export class EmptyCart extends Component {
    static propTypes = {
        openSignInSlider: PropTypes.func,
        isUserNotLoggedIn: PropTypes.bool,
        cartContent: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.func),
        isNative: PropTypes.bool,
    };

    static defaultProps = {
        openSignInSlider: () => {},
        isUserNotLoggedIn: true,
        cartContent: {},
        actions: {},
        isNative: false,
    };

    componentDidMount() {
        const { actions: { getMessageContent } = {} } = this.props;
        getMessageContent(EMPTY_CART_CONTENT, true);
    }

    render() {
        const { openSignInSlider, cartContent, isNative, actions, isUserNotLoggedIn } = this.props;

        const messageContentBody = get(cartContent, 'body', []);
        const contentLine1 = messageContentBody[0] || '';
        const contentLine2 = messageContentBody[1] || '';
        const contentLine3 = messageContentBody[2] || '';
        const signInLinkPlaceholder = '{sign_in_link}';
        const splitedSignInText = contentLine2.split(signInLinkPlaceholder);
        const signinLinkLeftContent = splitedSignInText[0] || '';
        const signinLinkRightContent = splitedSignInText[1] || '';

        const handleSignIn = () => {
            if (isNative) {
                actions.appSignIn(CART_DETAILS_GET_REQUEST);
            } else {
                openSignInSlider();
            }
        };

        return (
            <div
                id="empty-cart-wrapper"
                data-automation-id="empty-cart-wrapper"
                className={`${cx('emptyCartWrapper')} ${dt([
                    'font-normal',
                    'text-center',
                    'bg-white',
                    'sm:m-6',
                    'lg:mt-[112px]',
                    'lg:mb-[144px]',
                    'md:mb-16',
                    'smOnly:mb-10',
                ])}`}
            >
                {!isEmpty(messageContentBody) && (
                    <>
                        {contentLine1 && (
                            <div
                                data-automation-id="cart-is-empty"
                                className={`${cx('emptyCartContentBlock1')} ${dt([
                                    'text-xlarge',
                                    'font-semibold',
                                    'text-center',
                                    'text-black',
                                    'mx-auto',
                                    'my-0',
                                    'mb-2',
                                    'smOnly:py-0',
                                    'smOnly:px-5',
                                ])}`}
                                dangerouslySetInnerHTML={{ __html: contentLine1 }}
                            />
                        )}
                        {contentLine2 && isUserNotLoggedIn && (
                            <div
                                className={`${cx('emptyCartContentBlock2')} ${dt([
                                    'text-black',
                                    'text-center',
                                    'text-small',
                                    'mx-auto',
                                    'my-0',
                                    'smOnly:py-0',
                                    'smOnly:px-10',
                                ])}`}
                            >
                                {signinLinkLeftContent}
                                {contentLine2.indexOf(signInLinkPlaceholder) >= 0 && (
                                    <Button
                                        automationId="at-signin-link"
                                        buttonType="Link"
                                        size="Sm"
                                        key="at-signin-link"
                                        onClick={handleSignIn}
                                    >
                                        Sign in
                                    </Button>
                                )}
                                {signinLinkRightContent}
                            </div>
                        )}
                        {contentLine3 && (
                            <div
                                className={`${cx('emptyCartContentBlock3')} ${dt(['mt-7'])}`}
                                dangerouslySetInnerHTML={{ __html: contentLine3 }}
                            />
                        )}
                    </>
                )}
                {!isEmpty(cartContent) && cartContent.status !== 200 && (
                    <>
                        <p
                            data-automation-id="cart-is-empty"
                            className={`${cx('sm12', 'md12', 'cartIsEmpty')} ${dt([
                                'text-2xlarge',
                                'text-gray-70',
                            ])}`}
                        >
                            {EMPTY_CART_CART_IS_EMPTY}
                        </p>
                        {isUserNotLoggedIn && (
                            <div
                                className={dt([
                                    'py-0',
                                    'px-[11%]',
                                    'font-normal',
                                    'mb-5',
                                    'smOnly:mt-1',
                                ])}
                            >
                                <Button
                                    automationId="at-signin-link"
                                    buttonType="Link"
                                    size="Sm"
                                    key="at-signin-link"
                                    onClick={handleSignIn}
                                >
                                    Sign in
                                </Button>
                                <span className={dt(['text-gray-60'])}>
                                    {' '}
                                    to see items you may have added to your cart.
                                </span>
                            </div>
                        )}
                        <div
                            className={`${cx('buttonContainer')} ${dt([
                                'mt-6',
                                'smOnly:flex',
                                'smOnly:flex-col',
                                'items-center',
                            ])}`}
                        >
                            <Button
                                type="button"
                                automationId="at-start-shopping-button"
                                buttonType="Primary"
                                size="Lg"
                                key="at-start-shopping-button"
                                className={dt(['font-bold', 'w-[240px]', 'smOnly:mb-4'])}
                                onClick={handleShoppingBtn}
                            >
                                {EMPTY_CART_START_SHPNG}
                            </Button>
                            <Button
                                type="button"
                                automationId="empty-cart-coupons"
                                buttonType="Secondary"
                                size="Lg"
                                key="empty-cart-coupons"
                                className={dt([
                                    'font-bold',
                                    'w-[240px]',
                                    'smOnly:mr-0',
                                    'mr-5',
                                    'py-3',
                                    'px-4',
                                ])}
                                onClick={handleCouponBtn}
                            >
                                {EMPTY_CART_VIEW_COUPONS}
                            </Button>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cartContent: get(state, 'messageContentData.cf-empty-cart', {}),
    isNative: state.context.isNative,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign(messageContentAction, nativeAppAction), dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmptyCart);
